import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		position: fixed;
		top: 0px;
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100vw;
		min-height: 100dvh;
		background-color: rgb(0, 0, 0, 0.1);
	`,
	Spinner: styled.div`
		width: 80px;
		height: 80px;
		border: 12px solid ${({theme}) => theme.color.grey3};
		border-top: 12px solid ${({theme}) => theme.color.major};
		border-radius: 50%;
		animation: spinner 0.5s linear infinite;

		@keyframes spinner {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	`,
}
export default Style
